import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { addLocationSharing as addLocationSharingThunk } from '../operations/addLocationSharing';

import { STATUS_LOADING } from 'common/constants';

export const addLocationSharing = (builder: ActionReducerMapBuilder<CarsState>) => builder
  .addCase(addLocationSharingThunk.pending, (state) => {
    state.locationSharing.addingStatus = STATUS_LOADING.load;
  })
  .addCase(addLocationSharingThunk.fulfilled, (state, { payload }) => {
    state.locationSharing.addingStatus = STATUS_LOADING.done;
    state.locationSharing.lastAddedId = payload.id;
  })
  .addCase(addLocationSharingThunk.rejected, (state) => {
    state.locationSharing.addingStatus = STATUS_LOADING.error;
    state.locationSharing.lastAddedId = undefined;
  });
